import React from "react";

import { MoonOutlined, SunOutlined } from "@ant-design/icons";
import { Switch, Tooltip } from "antd";

import { useThemeMode } from "./ThemeModeProvider";

function ThemeModeSwitch() {
  const { themeMode, setThemeMode } = useThemeMode();
  const darkThemeEnabled = themeMode === "dark";

  const handleChange = React.useCallback(
    (checked: boolean) => {
      setThemeMode(checked ? "dark" : "light");
    },
    [setThemeMode],
  );

  return (
    <Tooltip title={darkThemeEnabled ? "Включить светлую тему" : "Включить тёмную тему"}>
      <Switch
        aria-label="Тёмная тема"
        checked={darkThemeEnabled}
        checkedChildren={<MoonOutlined aria-hidden />}
        onChange={handleChange}
        unCheckedChildren={<SunOutlined aria-hidden />}
      />
    </Tooltip>
  );
}

export default React.memo(ThemeModeSwitch);
